import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props extends ChildProps {
  caption?: string
  separator?: boolean
  fullWidth?: boolean
}

const SortButtonList = ({ children, caption, separator = false, fullWidth = false }: Props) => {
  return (
    <>
      <div className={clsx(['flex items-baseline gap-1', fullWidth && 'w-full'])}>
        {caption && (
          <Text color={TextColor.SECONDARY} nowrap>
            {caption}：
          </Text>
        )}

        <div
          className={clsx(
            'flex flex-wrap items-center gap-1',
            separator && 'border-primary ml-1 border-l pl-1',
            fullWidth && 'w-full'
          )}
        >
          {children}
        </div>
      </div>
    </>
  )
}

export default SortButtonList
